(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-helper"] && !Shopify.designMode) return;
  try {
    class ProductSizeHelper extends HTMLElement {
    connectedCallback() {
      this.sizeSelect = this.querySelector('[data-size-helper-size]');
      this.fitInputs = Array.from(this.querySelectorAll('[data-size-helper-fit]'));
      this.widthInputs = Array.from(this.querySelectorAll('[data-size-helper-width]'));
      this.result = this.querySelector('[data-size-helper-result]');
      this.resultTitle = this.querySelector('[data-size-helper-result-title]');
      this.resultHint = this.querySelector('[data-size-helper-result-hint]');
      this.suggestion = null;
      this.frame = null;

      this.handleChange = this.handleChange.bind(this);
      this.handleVariantChange = this.scheduleMark.bind(this);
      this.addEventListener('change', this.handleChange);
      document.addEventListener('variant:change', this.handleVariantChange);

      this.observer = new MutationObserver((mutations) => {
        if (mutations.some((mutation) => !this.contains(mutation.target))) {
          this.scheduleMark();
        }
      });
      this.observer.observe(this.closest('.product-info') || this.parentElement, { childList: true, subtree: true });

      this.handleChange();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.handleChange);
      document.removeEventListener('variant:change', this.handleVariantChange);
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }

    get variantPicker() {
      return document.querySelector(`variant-picker[form-id="${CSS.escape(this.dataset.formId)}"]`);
    }

    handleChange() {
      const sizeValue = this.sizeSelect ? this.suggestSize() : undefined;
      const widthValue = this.widthInputs.length ? this.suggestWidth() : undefined;

      // Suggest only once every question shown has an answer.
      this.suggestion = sizeValue === null || widthValue === null ? null : { size: sizeValue, width: widthValue };
      this.markSuggestedOptions();
    }

    suggestSize() {
      const usualSize = parseFloat(this.sizeSelect.value);
      if (Number.isNaN(usualSize)) return null;

      // Without the fit question, a half size rounds up (the size chart's "between sizes, size up").
      if (!this.fitInputs.length) return Math.ceil(usualSize);

      const fit = this.fitInputs.find((input) => input.checked)?.value;
      if (!fit) return null;
      return fit === 'roomy' ? Math.floor(usualSize) + 1 : Math.ceil(usualSize);
    }

    suggestWidth() {
      const answer = this.widthInputs.find((input) => input.checked)?.value;
      const valueByAnswer = {
        narrow: this.dataset.widthNarrowValue,
        regular: this.dataset.widthRegularValue,
        wide: this.dataset.widthWideValue,
      };
      return (answer && valueByAnswer[answer]) || null;
    }

    scheduleMark() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.markSuggestedOptions();
      });
    }

    findOptionSwatch(optionName, matches) {
      const picker = this.variantPicker;
      const container = picker?.querySelector(`[data-option-name="${CSS.escape(optionName || '')}"]`);
      if (!container) return null;

      const input = Array.from(container.querySelectorAll('input[data-value-name]')).find((candidate) =>
        matches(candidate.dataset.valueName)
      );
      if (!input || input.disabled) return null;

      const label = container.querySelector(`label[for="${CSS.escape(input.id)}"]`);
      if (!label || label.classList.contains('is-disabled')) return null;

      return { input, label };
    }

    markSuggestedOptions() {
      const picker = this.variantPicker;
      const matches = [];
      let allFound = Boolean(this.suggestion);

      if (this.suggestion) {
        const { size, width } = this.suggestion;
        if (size !== undefined) {
          const match = this.findOptionSwatch(this.dataset.sizeOption, (value) => parseFloat(value) === size);
          if (match) matches.push(match);
          else allFound = false;
        }
        if (width !== undefined) {
          const target = String(width).trim().toLowerCase();
          const match = this.findOptionSwatch(
            this.dataset.widthOption,
            (value) => (value || '').trim().toLowerCase() === target
          );
          if (match) matches.push(match);
          else allFound = false;
        }
      }

      // Tag only a complete suggestion, so the shopper never sees a width tagged without its size.
      const tagged = allFound ? matches.map((match) => match.label) : [];

      picker?.querySelectorAll('.block-swatch--suggested').forEach((label) => {
        if (!tagged.includes(label)) {
          label.classList.remove('block-swatch--suggested');
          label.removeAttribute('data-suggested-label');
        }
      });

      tagged.forEach((label) => {
        if (!label.classList.contains('block-swatch--suggested')) {
          label.classList.add('block-swatch--suggested');
          label.setAttribute('data-suggested-label', this.dataset.tagLabel || '');
        }
      });

      this.renderResult(allFound, allFound && matches.every((match) => match.input.checked));
    }

    fillTemplate(template, values, asElements) {
      const parts = [];
      let rest = template;
      while (rest) {
        const next = Object.keys(values)
          .map((token) => ({ token, index: rest.indexOf(token) }))
          .filter(({ index }) => index !== -1)
          .sort((a, b) => a.index - b.index)[0];
        if (!next) {
          parts.push(rest);
          break;
        }
        parts.push(rest.slice(0, next.index));
        if (asElements) {
          const valueElement = document.createElement('span');
          valueElement.className = 'size-helper__result-size';
          valueElement.textContent = values[next.token];
          parts.push(valueElement);
        } else {
          parts.push(values[next.token]);
        }
        rest = rest.slice(next.index + next.token.length);
      }
      return parts;
    }

    renderResult(available, allChosen) {
      if (!this.suggestion) {
        this.result.hidden = true;
        this.lastResultKey = null;
        return;
      }

      const values = {};
      if (this.suggestion.size !== undefined) values['{size}'] = String(this.suggestion.size);
      if (this.suggestion.width !== undefined) values['{width}'] = String(this.suggestion.width);

      const hintTemplate = available ? this.dataset.hintText : this.dataset.unavailableText;
      const showHint = Boolean(hintTemplate) && !allChosen;
      const resultKey = `${JSON.stringify(values)}|${available}|${showHint}`;

      if (resultKey === this.lastResultKey) return;
      this.lastResultKey = resultKey;

      const resultTemplate = this.dataset.resultText || Object.keys(values).join(' ');
      this.resultTitle.replaceChildren(...this.fillTemplate(resultTemplate, values, true));

      this.resultHint.textContent = showHint ? this.fillTemplate(hintTemplate, values, false).join('') : '';
      this.resultHint.hidden = !showHint;
      this.result.hidden = false;
    }
  }

  if (!customElements.get('product-size-helper')) {
    customElements.define('product-size-helper', ProductSizeHelper);
  }
  } catch(e) { console.error(e); }
})();

})();
